var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"title-area"},[_c('span',{staticClass:"material-icons icon",on:{"click":function($event){return _vm.moveToBasePath($event)}}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }